import { gql } from '@apollo/client';

export interface Input {
  name: string;
  seasonId: number;
}

export const MUTATION = gql`
  mutation DuplicateForm($formId: Int!, $newName: String!, $newSeasonId: Int!) {
    duplicateForm(input: { formID: $formId, newName: $newName, newSeasonId: $newSeasonId }) {
      id
      name
    }
  }
`;
